import { Flex } from '@chakra-ui/react';

function Licenses() {
  return <Flex data-id="8dd64be2dc01">Licenses</Flex>
}

export default Licenses;
